<re-alert *ngIf="alert" [type]="alert.type" (close)="alert = null">{{ alert.message }}</re-alert>
<re-alert *ngIf="showMessage" type="success" (close)="showMessage = false">
  <strong>Password changed successfully.</strong>
</re-alert>

<ng-template #popContent>
  <re-password-requirements [password]="answerSQForm.value.newPassword"
                            [username]="userName.value"
                            [validateFirstAndLastName]="false"
                            [domain]="selectedDomain">
  </re-password-requirements>

</ng-template>

<h1>
  Reset Password
</h1>

<div class="row">
  <div class="form-group col-sm-6 col-lg-4 input-required">
    <label for="userName">User Name</label>
    <input id="userName" [ngClass]="{'form-control': !success, 'form-control-plaintext': success}" type="text" [formControl]="userName" [readonly]="success" required>
    <small *ngIf="userName.invalid && userName.touched" class="text-danger">Please enter user name.</small>
  </div>
</div>

<div class="row col-12" *ngIf="success && !allowPasswordChange">
  <h5 class="mb-4">Please answer all the security questions to reset the password.</h5>
</div>

<div class="row col-12" *ngIf="success && allowPasswordChange">
  <h5 class="mb-4">Please enter new password.</h5>
</div>

<form [formGroup]="answerSQForm" (ngSubmit)="answerSQForm_onSubmit()" *ngIf="success">
  <div *ngIf="!allowPasswordChange">
    <div formArrayName="securityQuestions">
      <div *ngFor="let securityQuestion of answerSQForm.get('securityQuestions').controls; let i=index" [formGroupName]="i">
        <div class="row">
          <div class="form-group col-sm-6 col-lg-4 input-required">
            <label>{{securityQuestion.value.securityQuestion}}</label>
            <input type="text" class="form-control" formControlName="answer" autocomplete="off" required>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="allowPasswordChange">
    <div class="row">
      <div class="form-group col-sm-6 col-lg-4 input-required">
        <label for="newPassword">New password</label>
        <input id="newPassword" formControlName="newPassword" class="form-control" type="password" autocomplete="new-password" [ngbPopover]="popContent" popoverTitle="Password Requirements" placement="right" triggers="focus:blur outsideClick"
               (input)="valueChange()">
        <small *ngIf="answerSQForm.controls['newPassword'].hasError('required') && answerSQForm.controls['newPassword'].touched" class="text-danger">Please enter new password.</small>
        <small *ngIf="!validatePassword() && answerSQForm.controls['newPassword'].touched" class="text-danger">
          New password does not match with password requirements.
        </small>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-sm-6 col-lg-4 input-required">
        <label for="confirmPassword">Confirm new password</label>
        <input id="confirmPassword" formControlName="confirmPassword" class="form-control" type="password" autocomplete="new-password">
        <small *ngIf="answerSQForm.controls['confirmPassword'].hasError('required') && answerSQForm.controls['confirmPassword'].touched" class="text-danger">Please enter confirm password.</small>
        <small *ngIf="answerSQForm.controls['confirmPassword'].hasError('compare') && answerSQForm.controls['confirmPassword'].touched" class="text-danger">Confirm password does not match with new password.</small>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="form-group mb-4">
        <button class="btn btn-default" type="button" (click)="redirectBack()">Back</button>
        <button class="btn btn-primary" type="button" *ngIf="!allowPasswordChange" (click)="validateSecurityQuestions()" [disabled]="answerSQForm.invalid">Next</button>
        <button class="btn btn-success" type="submit" *ngIf="allowPasswordChange" [disabled]="answerSQForm.invalid">Save</button>
      </div>
    </div>
  </div>
</form>

<div class="row" *ngIf="!success">
  <div class="col-12">
    <div class="form-group mb-4">
      <button class="btn btn-default" type="button" (click)="redirectBack()">Back</button>
      <button class="btn btn-primary" type="button" [disabled]="userName.invalid" (click)="getUserSecurityQuestions(userName.value)">Continue</button>
    </div>
  </div>
</div>

